import { graphql } from "../gql";

export default graphql(`
  query GetGameInjuries($input: OddsMarketTypesInput!) {
    event(input: $input) {
      playerInjuries {
        teamInfo {
          colors {
            primary
          }
          logo {
            svg
          }
          name
          shortName
          teamJersey {
            svg
          }
        }
        position
        name
        firstName
        lastName
        injury {
          status
          description
          injured
          publishedAt
        }
      }
    }
  }
`);
